export const SVG_BUNDLE_PREFIX = "__SVG_BUNDLE__:";

export type SvgBundle = {
  question?: string;
  options?: Record<string, string>;
};

export function parseSvgBundle(svgCode?: string | null): SvgBundle | null {
  if (!svgCode || !svgCode.startsWith(SVG_BUNDLE_PREFIX)) {
    return null;
  }
  try {
    const raw = svgCode.slice(SVG_BUNDLE_PREFIX.length);
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      return null;
    }
    return parsed as SvgBundle;
  } catch {
    return null;
  }
}

// For a question SVG field that may be a bundle (MCQ) or a plain <svg> string (learn/practice/short-answer).
export function extractQuestionSvg(svgCode?: string | null): string | null {
  if (!svgCode) {
    return null;
  }
  const bundle = parseSvgBundle(svgCode);
  if (bundle) {
    return bundle.question || null;
  }
  return svgCode.startsWith(SVG_BUNDLE_PREFIX) ? null : svgCode;
}
